<template>
  <div class="tasks-list">
    <ul class="tasks-list__list">
      <li class="tasks-list__item" v-for="task in tasks" :key="task.id">
        <TaskCheckbox
          :readonly="true"
          :value="task.status === 'finished'"
          :indeterminate="task.status === 'stale'"
          :disabled="true"
          @click.native="handleTaskClick(task)"
        >
          <div class="tasks-list__task">
            <span class="tasks-list__task-name">{{ task.name }}</span>
            <span class="tasks-list__task-date">{{ formatDateTime(task.finish_date, 'ddd, DD MMMM') }}</span>
          </div>
        </TaskCheckbox>
      </li>
    </ul>
    <Paginator
      class="tasks-list__pagination"
      :hide-if-one-page="true"
      :current-page="currentPage"
      :page-size="pageSize"
      :items-count="totalTasks"
      @page-changed="handlePageChanged"
    />
  </div>
</template>

<script>
import { dateTimeFormatter } from '@/shared/lib/date-time';
import { TaskCheckbox } from '@/shared/ui/form';
import { Paginator } from '@/shared/ui/paginator';

export default {
  props: {
    currentPage: {
      type: [Number, null],
      required: true,
    },
    pageSize: {
      type: [Number, null],
      required: false,
      default: 10,
    },
    totalTasks: {
      type: [Number, null],
      required: true,
    },
    tasks: {
      type: Array,
      required: true,
    },
  },
  mixins: [ dateTimeFormatter ],
  components: { TaskCheckbox, Paginator },
  methods: {
    handlePageChanged(page) {
      this.$emit('page-changed', page);
    },
    handleTaskClick(task) {
      this.$emit('task-clicked', task);
    },
  },
};
</script>

<style lang="scss" scoped>
.tasks-list {
  position: relative;
  padding-bottom: 65px;
  height: 100%;

  &__item {
    border: 1px solid #E4E4E4;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__task-name {
    display: block;
    font-size: 16px;
    line-height: 1.3;
    font-weight: 500;
  }

  &__task-date {
    display: block;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.3;
    color: #858C95;
    text-transform: capitalize;
  }

  &__pagination {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
</style>
